<template>
  <v-app>
    <SideBar v-if="login.auth" :drawer.sync="drawer" />

    <v-app-bar v-if="login.auth" app color="blue darken-2" dense dark>
      <v-app-bar-nav-icon class="white--text" @click="drawer = true" />

      <div class="d-flex align-center">
        <v-toolbar-title v-text="title" />
      </div>

      <v-spacer />

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon dark @click="logoutHandle">
            <v-icon v-text="'mdi-logout-variant'" />
          </v-btn>
        </template>
        <span v-text="'Cerrar sesión'" />
      </v-tooltip>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <v-footer v-if="login.auth" app padless>
      <v-row dense>
        <v-col cols="6">
          <small v-text="login.email" class="pl-1 font-weight-bold" />
        </v-col>
        <v-col cols="6" class="text-right">
          <small v-text="version" class="pr-1" />
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
import Axios from "axios";
import { URL_API, headers } from "./control";
import SideBar from "./components/SideBar.vue";

export default {
  components: {
    SideBar,
  },

  data() {
    return {
      drawer: false,
      login: this.$store.getters.getLogin,
      title: "Sinergia Médica",
      version: "v1.26.10.07",
    };
  },

  methods: {
    logout() {
      this.$store.dispatch("logOutAction");
      window.location.assign("/inicio_sesion");
    },

    logoutHandle() {
      this.$swal
        .fire({
          showCancelButton: true,
          cancelButtonText: "No",
          confirmButtonText: "Sí",
          icon: "warning",
          text: "¿Cerrar sesión?",
        })
        .then((response) => {
          if (response.isConfirmed) {
            const token = this.$store.getters.getLogin.token;

            Axios.get(`${URL_API}/auth/logout`, headers(token))
              .then((response) => {
                this.logout();
              })
              .catch((err) => {
                this.logout();
              });
          }
        });
    },
  },
};
</script>

<style>
.toolbar {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
}

.v-main {
  background-color: #f8f9fa;
}

.swal2-html-container,
.swal2-styled {
  font-family: "Roboto" !important;
}
</style>
